import { api } from '@app/config/axios';
import { PermissionsEnum } from '@features/access-control/dto/permissions';

export async function getMyPermissionsService() {
  const response = await api.get<PermissionsEnum[]>(`/permissions/user/me`);
  return response.data;
}
